import '@awesome.me/kit-b257fa7ca4/icons/css/light.css';
import { Beech } from './beech';
import { Logg } from './logg';
import BeechUiRoot from '../view/root.vue';
import Vue from 'vue';
import $ from 'jquery';

// Make jQuery available globally
(window as any).$ = $;
(window as any).jQuery = $;

(function () {
	// Better console
	(<any>window).logg = new Logg();

	$(document).on('click', '#gpsh-alerts span', (e: Event) => {
		$(<any>e.target)
			.parent()
			.remove();
	});

	// Public runtime API: used by Vue components (view/*.vue), the renderer's
	// notify/embedded modules, and the Electron main process dial server
	// (electron/main.ts). Required at runtime — do not remove.
	(<any>window).beech = new Beech();

	// Detect route and apply appropriate container styling
	const path = window.location.pathname;
	const appRoot = document.getElementById('gpsh-app-root');

	if (navigator.userAgent.includes('Electron') || path === '/electron') {
		document.body.classList.add('is-electron');
	}

	if (appRoot && appRoot.parentNode) {
		const container = document.createElement('div');
		if (path === '/demo') {
			container.id = 'gpsh-demo-container';
		} else if (path === '/electron') {
			container.id = 'gpsh-electron-container';
		} else {
			container.id = 'gpsh-embed-container';
		}
		appRoot.parentNode.insertBefore(container, appRoot);
		container.appendChild(appRoot);
	}

	// Vue doesn't surface component errors to window.onerror; capture them here.
	Vue.config.errorHandler = (err, _vm, info) => {
		logg.error('vue.errorHandler', { error: err, info: info });
		(<any>window).beech?.server?.sendClientLog('vue.errorHandler', err?.message ?? String(err));
	};

	// UI Components
	new Vue({
		render: (h) => h(BeechUiRoot)
	}).$mount('#gpsh-app-root');
})();
